exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttonClass[data-v-57b64d3e]{display:flex;flex-direction:row;color:#fff;padding:5px;font-size:12px;font-weight:700;text-transform:uppercase}.grid[data-v-57b64d3e]{display:grid;grid-template-columns:repeat(auto-fill,minmax(280px,1fr));grid-gap:20px;align-items:stretch}.grid>article[data-v-57b64d3e]{border:1px solid #ccc;box-shadow:2px 2px 6px 0 rgba(0,0,0,.3)}.grid>article img[data-v-57b64d3e]{max-width:100%}.grid .text[data-v-57b64d3e]{padding:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-57b64d3e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Offers/OfferGrid.vue
// module id = 147
// module chunks = 0